import type { FC, PropsWithChildren, ReactElement } from 'react';

import { JurisdictionNL } from '@pp/core/src/components/compliance/JurisdictionNL';
import { Fullscreen } from '@pp/core/src/components/fullscreen/Fullscreen';
import { DrawerRoot } from '@pp/core/src/components/game/drawer/root/DrawerRoot';
import { VolumeRestorer } from '@pp/core/src/components/settings/VolumeRestorer';
import { useInitializationSlice } from '@pp/core/src/store/slices/initialization/selectors';
import { useMasterVolumeControl } from '@pp/core/src/store/slices/settings/hooks/useVolumeControl';

import styles from './CrashGameBody.module.css';

export const CrashGameBody: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const isReadyToRender = useInitializationSlice.getIsReadyToRender();
  useMasterVolumeControl();

  return (
    <>
      {isReadyToRender ? (
        <div className={styles.gameBody}>
          <div className={styles.gameBody__container}>{children}</div>
          <DrawerRoot />
          <VolumeRestorer />
          <JurisdictionNL />
        </div>
      ) : null}
      <Fullscreen isReadyToRender={isReadyToRender} />
    </>
  );
};
